import type React from 'react';

const resetInputIME = (input: HTMLInputElement) => {
  input.blur();
  requestAnimationFrame(() => input.focus());
};

export const handleInputCompositionStart = (
  e: React.CompositionEvent<HTMLInputElement>
) => {
  resetInputIME(e.currentTarget);
};
